import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SearchBarComponent } from '../../search-bar/search-bar.component';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-auto-complete-bar',
  templateUrl: './auto-complete.component.html',
  imports: [
    MatFormField,
    MatInput,
    MatAutocompleteTrigger,
    FormsModule,
    ReactiveFormsModule,
    MatAutocomplete,
    MatOption
],
})
export class AutoCompleteComponent extends SearchBarComponent {
  suggestionSelected({ option }) {
    this.control.setValue(option.viewValue);
    this.props() && this.props().field
      ? this.search.emit({ [this.props().field]: option.viewValue })
      : this.search.emit(option.viewValue);
  }
}
